export const SET_ACCESSRULELIST = "SET_ACCESSRULELIST";
export const SET_ACCESSOBJECT = "SET_ACCESSOBJECT";

